// Copyright (c) 2021 Deere & Company

import './index.scss';

import * as busyCounter from '../../shared/action-creator/busy-counter';
import React, { Component } from 'react';
import {
    addScreenDetails,
    deleteScreenDetails,
    getScreenDetails, getScreenGroups
} from './repositories';
import { createErrorMessage, createSuccessMessage } from '../../shared/action-creator/alert-messages';
import BusyCounterLoadingIndicator from '../../shared/components/busyCounter/busy-counter-loading-indicator';
import LabeledInput from '../../shared/components/labeled-input';
import LabeledTextArea from '../../shared/components/labeled-textarea';
import { ModalBase } from '../../shared/components/modals/modal-base';
import OptionsDropDown from '../../shared/components/options-drop-down';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { showLoadingIndicator } from '../../shared/state/busy-counter';
import { withRouter } from 'react-router-dom';

class Of06ScreenSubstitution extends Component {

    state = {
        screenGroups: [],
        selectedGroup: '',
        screenDetails: null,
        key: '',
        type: '',
        note: '',
        addType: '',
        modalOpen: false
    };

    componentDidMount = () => {

        this.getOf06ScreenGroups();
        // this.getFamilyWeek();

    }

    handleGroupChange ( val ) {

        this.setState( {
            selectedGroup: val,
            screenDetails: null
        } );

        if ( val !== '' || val !== '-1' ) {

            this.getOf06ScreenDetails( val );

        }

    }

    getOf06ScreenGroups () {

        this.props.increaseCounter();
        getScreenGroups( ).then( response => {

            this.setState( {
                screenGroups: response
            } );
            this.props.decreaseCounter();

        } ).catch( () => {

            this.props.decreaseCounter();

        } );

    }

    getOf06ScreenDetails ( val ) {

        this.props.increaseCounter();
        getScreenDetails( val ).then( response => {

            this.setState( {
                screenDetails: response
            } );
            this.props.decreaseCounter();

        } ).catch( () => {

            this.props.decreaseCounter();

        } );

    }

    deleteKey = ( type, obj ) => {

        this.setState( {
            modalOpen: true,
            key: obj.constraintKey,
            type: obj.constraintType,
            note: '',
            addType: 'DELETE'
        } );

    }

    addKeyType = () => {

        const {
            note, selectedGroup, key, type, addType
        } = this.state;

        const isDelete = addType === 'DELETE';

        const payload = {
            updateNote: note,
            groupName: selectedGroup,
            constraintKey: key,
            constraintType: type
        };

        if ( isDelete ) {

            this.props.increaseCounter();
            deleteScreenDetails( payload ).then( response => {

                if ( response.status === 201 ) {

                    this.setState( {
                        modalOpen: false
                    } );
                    this.props.createSuccessMessage( `Deleted Constraint key ${key}, type ${type}, from Group ${selectedGroup}` );

                    this.getOf06ScreenDetails( selectedGroup );

                }
                this.props.decreaseCounter();

            } ).catch( () => {

                this.props.decreaseCounter();

            } );

        } else {

            const addPayload = {
                ...payload,
                actionType: addType === 'AND' ? 'Add AND' : 'Add OR'
            };
            this.props.increaseCounter();
            addScreenDetails( addPayload ).then( response => {

                if ( response.status === 201 ) {

                    this.setState( {
                        modalOpen: false
                    } ); this.props.createSuccessMessage( `Added Constraint key ${key}, type ${type}, to Group ${selectedGroup}` );

                    this.getOf06ScreenDetails( selectedGroup );

                }
                this.props.decreaseCounter();

            } ).catch( () => {

                this.props.decreaseCounter();

            } );

        }

    }

    createKeyTypeTable = ( type, data ) => (
        <table>
            <thead>
                <th>Constraint Key</th>
                <th>Constraint Type</th>
                <th>
                    <button
                        className=""
                        type="button"
                        onClick={() => this.setState( {
                            modalOpen: true,
                            key: '',
                            type: '',
                            note: '',
                            addType: type
                        } )}
                    >
                        <span> Add </span>
                    </button>
                </th>
            </thead>
            <tbody>
                {data && data.length > 0 && data.map( ( i, index ) => (
                    <tr key={`screen-sub-${index}`}>
                        <td>{i.constraintKey}</td>
                        <td>{i.constraintType}</td>
                        <td>
                            <button className="" type="button" onClick={() => this.deleteKey( type, i )}>
                                <span> Delete </span>
                            </button>
                        </td>
                    </tr>
                ) )}
            </tbody>
        </table>
    );

    render () {

        const {
            screenGroups, selectedGroup, screenDetails,
            key, type, note, addType, modalOpen
        } = this.state;
        const isDelete = addType === 'DELETE';
        const msg = isDelete ? `${addType} Constraint` : `Add ${addType} Constraint`;

        return (
            <section className="main-content">
                <BusyCounterLoadingIndicator busyCounter={this.props.busyCounter} />
                <header>
                    <h2 className="page-header">OF06 Screen Substitution</h2>
                </header>

                <main>
                    <section className="section-container">
                        <div className="atp-top-options atp-screen-substitution-top-options">
                            <OptionsDropDown
                                className="atp-screen-substitution-select"
                                label="Group"
                                isPlaceholderTranslated={true}
                                onChange={this.handleGroupChange.bind( this )}
                                optionDisplayAttributes={['value']}
                                optionKey="id"
                                options={screenGroups}
                                placeholder="Select Group"
                                selectedValue={selectedGroup}
                            />
                        </div>
                        {screenDetails && (
                            <div className="atp-screen-substitution-results">
                                <div className="atp-screen-substitution-table-div">
                                    <div className="atp-screen-substitution-section-heading">
                                        *** OR *** ONE OF THESE CONSTRAINS MUST BE
                                        ON AN ORDER TO SELECT GROUP ***
                                    </div>
                                    {this.createKeyTypeTable( 'OR', screenDetails.groupORElements )}
                                </div>
                                <div className="atp-screen-substitution-table-div">
                                    <div className="atp-screen-substitution-section-heading">
                                        *** AND (OPTIONALLY) *** ONE OF THESE CONSTRAINS MUST BE
                                        ON AN ORDER TO SELECT GROUP ***
                                    </div>
                                    {this.createKeyTypeTable( 'AND', screenDetails.getGroupElementsAND )}
                                </div>
                            </div>
                        )}
                    </section>
                    <ModalBase
                        body={(
                            <div className="modal-container screen-substitution-modal-body">
                                <LabeledInput
                                    className="screen-substitution-labeled-input"
                                    name="key"
                                    isEditable={!isDelete}
                                    isRequired={!isDelete}
                                    label="Key:"
                                    value={key}
                                    onChange={val => this.setState( { key: val.target.value } )}
                                />
                                <LabeledInput
                                    className="screen-substitution-labeled-input"
                                    name="type"
                                    isEditable={!isDelete}
                                    isRequired={!isDelete}
                                    label="Type:"
                                    value={type}
                                    onChange={val => this.setState( { type: val.target.value } )}
                                />
                                <LabeledTextArea
                                    className="screen-substitution-labeled-text-area"
                                    rows="5"
                                    name="note"
                                    isEditable={true}
                                    isRequired={true}
                                    label="Update Note:"
                                    value={note}
                                    onChange={val => this.setState( { note: val.target.value } )}
                                />
                            </div>
                        )}
                        header={(
                            <div className="screen-substitution-modal-header"> {msg} </div>
                        )}
                        onHide={this.handleConfirm}
                        isOpen={modalOpen}
                        footer={(
                            <span className="screen-substitution-modal-footer">
                                <button className="close-button" type="button" onClick={() => this.setState( { modalOpen: false } )}>
                                    Cancel
                                </button>
                                <button className="primary-button" type="button" onClick={this.addKeyType}>
                                    {addType === 'DELETE' ? 'Delete' : 'Add'}
                                </button>
                            </span>
                        )}
                        size=""
                    />
                </main>
            </section>
        );

    }

}

const mapStateToProps = state => ( {
    busyCounter: showLoadingIndicator( state.application.busyCounter ),
    unit: state.application.unit,
    accessToken: state.oktaState.oktaState.accessToken
} );

Of06ScreenSubstitution.displayName = 'Of06ScreenSubstitution';
Of06ScreenSubstitution.propTypes = {
    busyCounter: PropTypes.bool.isRequired,
    increaseCounter: PropTypes.func.isRequired,
    decreaseCounter: PropTypes.func.isRequired,
    unit: PropTypes.object,
    location: PropTypes.object,
    createSuccessMessage: PropTypes.func
};
const mapDispatchToProps = dispatch => ( {
    increaseCounter: () => dispatch( busyCounter.increaseBusyCounter() ),
    decreaseCounter: () => dispatch( busyCounter.decreaseBusyCounter() ),
    createSuccessMessage: message => dispatch( createSuccessMessage( message ) ),
    createErrorMessage: message => dispatch( createErrorMessage( message ) )
} );
export default connect(
    mapStateToProps, mapDispatchToProps
)( withRouter( Of06ScreenSubstitution ) );
